import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import {
    DataGrid, GridRowsProp, GridColDef, DataGridPro, GridToolbar, GridRowModes,

    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';


const columns = [
   
    { field: 'partnerID', headerName: 'partnerID', width: 150 },
    { field: 'partnerName', headerName: 'Partner Name', width: 150 },
    { field: 'contactNumber', headerName: 'Contact Number', width: 150 },
   
    { field: 'contactPerson', headerName: 'Conatct Person', width: 150 },
    {
        field: 'partnerClass',
        headerName: 'Class',
        width: 150,
        renderCell: (params) => {
            // Define styles and labels for each partner class
            const partnerClassStyles = {
                Premium: {
                    label: 'Premium',
                    backgroundColor: 'gold',
                    color: 'black',
                },
                Basic: {
                    label: 'Basic',
                    backgroundColor: '#90CAF9',
                    color: 'black',
                },
                Standard: {
                    label: 'Standard',
                    backgroundColor: '#E0E0E0',
                    color: 'black',
                },
            };

            // Get the style and label based on the value
            const classStyle =
                partnerClassStyles[params.value] || {
                    label: 'Unknown',
                    backgroundColor: 'gray',
                    color: 'white',
                };

            return (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Chip
                        label={classStyle.label} // Display dynamic label
                        style={{
                            backgroundColor: classStyle.backgroundColor, // Dynamic background color
                            color: classStyle.color, // Dynamic text color
                            fontWeight: 'bold',
                        }}
                        size="small" // Smaller chip size
                    />
                </div>
            );
        }

    },
    {
        field: 'isActive',
        headerName: 'Status',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Active' : 'Inactive'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : '#cf0a0a', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },

    {
        field: 'isVerified',
        headerName: 'Verification',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Approved' : 'Pending'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : 'blue', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },
];

export default function PartnerTable({ PartnersData }) {

    const filterColumns = ({ field, columns, currentFilters }) => {
        // remove already filtered fields from list of columns
        const filteredFields = currentFilters?.map((item) => item.field);
        return columns
            .filter(
                (colDef) =>
                    colDef.filterable &&
                    (colDef.field === field || !filteredFields.includes(colDef.field)),
            )
            .map((column) => column.field);
    };

    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 5 }); // Initial pagination state

    const handlePaginationChange = (newPaginationModel) => {
        setPaginationModel(newPaginationModel);
    };

    const navigate = useNavigate();
    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        navigate(`/editpartner/${params.id}/false`, { state: { partner: params.row } });
    };


    const getColumnForNewFilter = ({ currentFilters, columns }) => {
        const filteredFields = currentFilters?.map(({ field }) => field);
        const columnForNewFilter = columns
            .filter(
                (colDef) => colDef.filterable && !filteredFields.includes(colDef.field),
            )
            .find((colDef) => colDef.filterOperators?.length);
        return columnForNewFilter?.field ?? null;
    };
    const CustomToolbar = (props) => (
        <GridToolbarContainer>
            <EditToolbar {...props} />
            <GridToolbar />
        </GridToolbarContainer>
    );


    const handleAddPartner = () => {

        navigate('/addpartner')
    };
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            handleAddPartner();
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    New Partner
                </Button>
            </GridToolbarContainer>
        );
    }
    return (
        <div style={{ height: '100%', width: '100%' }}>
            <DataGrid rows={PartnersData} columns={columns}
                pagination
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationChange}
                pageSizeOptions={[5, 10, 25]} // Customize page size options
                slots={{ toolbar: CustomToolbar }}
                onRowClick={handleRowClick}
                slotProps={{
                    filterPanel: {
                        filterFormProps: {
                            filterColumns,
                        },
                        getColumnForNewFilter,
                    },
                }}
            />

        </div>
    );
}